// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commentary-item-header__title--link,.commentary-item-header__title--nolink{font-weight:500;font-size:16px;line-height:24px;letter-spacing:0px}.commentary-item-header__icon{color:#999;font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;margin-left:8px}\n", ""]);
// Exports
module.exports = exports;
